/*
 * @Description:
 * @Date: 2022-07-14 16:42:58
 */
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = (require as any).context('@/assets/svg', false, /\.svg$/);
export default () => {
  requireAll(req);
};
